module.exports = __webpack_public_path__ + "static/media/gym.31621241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/qci/backgrounds/gym.jpg
// module id = 2383
// module chunks = 0